import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-table-3',
  templateUrl: './pricing-table-3.component.html',
})
export class PricingTable3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
